import { DownloadUrlButton } from '@app/core/media-player/DownloadUrlButton';
import { buildAuditMediaFileUrl } from '../../helpers/build-audit-media-file-url';

interface Props {
  readonly mediaId: string;
  /** Time in milliseconds before re-enabling the button after a download click. */
  readonly timeout?: number;
  readonly size?: 'small' | 'medium' | 'large';
  readonly disabled?: boolean;
}

/**
 * Audit-audio download control: builds the forced-download URL and delegates to DownloadUrlButton.
 */
export function DownloadAudioBtn({ mediaId, timeout, size, disabled }: Props) {
  const url = buildAuditMediaFileUrl(mediaId, { download: true });

  return (
    <DownloadUrlButton
      url={url}
      timeout={timeout}
      size={size}
      disabled={disabled}
      color="primary"
      iconOnly
    />
  );
}
